  showNewsletterPanel =function (e){$(".newsletterModal #email").val(e);$(".newsletterModal .email_msg").hide();$(".ui.modal.newsletterModal").modal("show");}

  periodicalyShowNewsletterPanel = function(){
    if(!getCookie('newsletterSubscribed'))
    {
      var newsletterCookieName = 'periodicalyShowNewsletterPanel';

      var c = getCookie(newsletterCookieName);
      if(c){
        var diff = differenceInDays(new Date(c), new Date()); console.log(diff);
        if(diff >= 3)
        {
          setCookie(newsletterCookieName, new Date(), 40000);

          showNewsletterPanel('');
        }
      }
      else
      {
        setCookie(newsletterCookieName, new Date(), 40000);
      }
    }
  }

  newsletterSubscribeSetCookie = function(){
    setCookie('newsletterSubscribed', true, 40000);
  }

  setCookie = function(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
  }

  getCookie = function(k){
    return(document.cookie.match('(^|; )'+k+'=([^;]*)')||0)[2]
  }

  differenceInDays = function(d1, d2) {
    var t2 = d2.getTime();
    var t1 = d1.getTime();

    return parseInt((t2-t1)/(24*3600*1000));
  },

  window.onload = function() {
    if(window.location.hash == '#register'){
      //toggleRegisterModal();
      setTimeout(
        function(){showNewsletterPanel();},
        500
      );
    }
    else{
      //periodicalyShowNewsletterPanel();
      setTimeout(
        function(){periodicalyShowNewsletterPanel();},
        500
      );
    }
  }
